export default "__VITE_ASSET__BuDMwMnq__"